export default {
  homePage: '首頁',
  chatPage: '聊天',
  contactUs: '聯絡我們',
  submitRequest: '提交請求',
  question: '問題',
  subject: '主旨',
  description: '描述',
  email: '你的電子郵件',
  attach: '最多附加 4 個檔案。檔案大小必須小於 10 MB。',
  delete: '刪除',
  sizeExceeded: '檔案大小必須小於 10 MB。',
  numberExceeded: '最多可以附加 4 個檔案。',
  wrongFormat: '附件必須是以下類型的檔案：.jpg、.jpeg、.png、.bmp、.tif、.tiff、.gif、.webp、.avi、.mp4、.mov、.flv、.mkv、.webm、.txt、.csv。',
  send: '傳送',
  messageSent: '已成功傳送你的訊息。我們的支援團隊審查你的請求後，我們將會根據你輸入的電子郵件地址聯絡你。',
  formUnavailable: '工作單建立表目前無法使用。你可以透過說明中心提交工作單。',
  helpCenter: '前往說明中心。',
  issueEmpty: '請選取問題類型。',
  subjEmpty: '請輸入問題主旨。',
  descEmpty: '請輸入你的問題。',
  emailInvalid: '請輸入你的電子郵件地址。確認電子郵件正確。',
  // Issue types
  type: '選取問題類型',
  gameQuestion: '遊戲問題',
  techIssue: '技術問題',
  paymIssue: '付款問題',
  gameplayIssues: '遊戲進行問題',
  feedback: '意見回饋和建議',
  dpo: '隱私保護請求 / DPO 聯絡',
  // GDPR form
  gdprCheckbox: `我已閱讀並理解以上條件。`,
  gdprType: '選取刪除原因 (可選)',
  gdprRestart: '我想開始新遊戲',
  gdprBored: `我不喜歡這個遊戲`,
  gpdrMultiacc: `我有另一個帳戶，不需要這一個`,
  gdprExpectations: `遊戲不符合我的期待`,
  gdprDataSafety: `我不想分享個人資料`,
  gdprPrices: '遊戲太昂貴',
  gdprOther: '其它',
  gdprCreate: `<p>你可以在此請求完全刪除帳戶和所有相關資料。如果你只想刪除特定伺服器上的遊戲個人檔案，請按下遊戲主畫面的齒輪圖示，向下捲動，並按下支援選項旁邊的開啟。在圖表中，前往帳戶和隱私 → 刪除帳戶 → 刪除伺服器上的設定檔。</p>
<p>如果你選擇刪除資料，將會失去所有進度、分數和成就。<strong>將會刪除你在所有伺服器的所有進度且無法復原。也會在我們的伺服器上刪除</strong>。</p>
<p>我們根據法律要求，嚴格保護你的資料並尊重你的權利。我們出於必要收集資料，讓您可以存取專案。如果你在我們完成資料刪除請求之後執行專案，你將需要再次接受我們的<a href="https://www.nexters.com/hwa/tos_zh_tw/">條款</a>和<a href="https://www.nexters.com/hwa/privacy_zh_tw/">隱私權政策</a>。在此情況下，我們可能會重新開始收集你的資料。在你完成請求之前，你可以存取進度和成就，不必另外接受我們的<a href="https://www.nexters.com/hwa/tos_zh_tw/">條款</a>和<a href="https://www.nexters.com/hwa/privacy_zh_tw/">隱私權政策</a>。</p>
<p>如果你確認此請求，將會在確認日期起 30 天內完成。此外，也請注意此期間是最長時間。因此，我們可能會按照內部請求處理程序提早完成請求。請謹慎提出刪除資料的請求：此流程無法復原。</p>
此外，如果你改變主意，請在時間限制（14 天）內撤銷請求。若要取消請求：
<ol><li>點選遊戲主畫面右上角的齒輪圖示，向下捲動，並按下刪除我的帳號以及伺服器上的所有資料選項旁邊的開啟。你會看見取消按鈕。按下即可取消請求。</li>
<li>或者，您可以使用聊天機器人取消請求。點選遊戲主畫面右上角的齒輪圖示，向下捲動，並按下支援選項旁邊的開啟按鈕。在聊天中，前往帳戶和隱私 → 刪除帳戶 → 刪除《勇士爭霸》帳戶 → 取消帳戶刪除請求。</li></ol>
<p>如果你同意以上條件並想要繼續，請按下確認。</p>`,
  confirm: '確認',
  gdprConfirmed1: '已接受你的刪除請求。將會在以下請求建立日期起 30 天內刪除你在所有伺服器的所有進度且無法復原 —',
  gdprConfirmed2: `<p>你可以在前 14 天內取消此請求。若要這麼做：
<ol><li>點選遊戲主畫面右上角的齒輪圖示，向下捲動，並按下刪除我的帳號以及伺服器上的所有資料選項旁邊的開啟。你會看見取消按鈕。按下即可取消請求。</li>
<li>或者，您可以使用聊天機器人取消請求。點選遊戲主畫面右上角的齒輪圖示，向下捲動，並按下支援選項旁邊的開啟按鈕。在聊天中，前往帳戶和隱私 → 刪除帳戶 → 刪除《勇士爭霸》帳戶 → 取消帳戶刪除請求。</li></ol></p>
<p>你也會在第 7 日和第 14 日收到寄至遊戲內郵件的提醒信。<strong>請注意，你無法在 14 天後取消帳戶刪除請求。</strong></p>`,
  gdprCancel: `<p>如果你想要取消帳戶刪除請求，請按下取消刪除我的帳戶按鈕。</p>`,
  gdprCancelConfirmed: `<p>我們為你的資料提供適當的保護程度，並根據法律要求嚴格尊重你的權利。</p>
  <p><strong>根據你的請求，會撤銷你的刪除要求，且不會刪除你的進度。</strong></p>
  <p>請注意，將會繼續收集資料。</p>`,
  gdprCancelButton: `取消刪除我的帳戶`,
  // Meya 
  digestEmpty: '歡迎！如果你有任何遊戲相關問題，我們的支援團隊十分樂意協助！',
  loadingChat: '正在載入聊天…',
  loadingChatStart: `如果沒有出現聊天按鈕，按一下`,
  loadingChatLink: `此處 `,
  loadingChatEnd: `以取得聯繫！`,
  openChat: '聊天',
  // Links
  hcLink: 'https://support-hwa.nexters.com/hc/en-us',
  // Help Center
  popularTopics: '推廣文章',
  search: '搜尋',
  searchResults: '- 結果',
  showAll: '顯示全部',
  error: '發生錯誤。請稍後再試。',
}